export default "__VITE_ASSET__BCohuaQF__"